import { inject } from '@angular/core';
import { MaybeAsync } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { map } from 'rxjs';
import { UnsavedChangesDialogComponent } from '@shared/components/unsaved-changes-dialog/unsaved-changes-dialog.component';

export interface HasUnsavedTyreActivityChanges {
  hasUnsavedChanges(): boolean;
}

export const unsavedTyreActivityChangesGuard = (component: HasUnsavedTyreActivityChanges): MaybeAsync<boolean> => {
  if (!component.hasUnsavedChanges()) {
    return true;
  }

  return inject(MatDialog).open<UnsavedChangesDialogComponent, void, boolean>(
    UnsavedChangesDialogComponent,
    { width: '500px', height: 'auto', autoFocus: false },
  ).afterClosed().pipe(
    map(confirmed => confirmed === true),
  );
};
